import * as React from 'react'

function SvgOutgoing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.848 3.234a1.992 1.992 0 00-.427-.642l-.013-.013A1.994 1.994 0 0026 2H11a2 2 0 100 4h10.172L2.586 24.586a2 2 0 102.828 2.828L24 8.828V19a2 2 0 104 0V4v-.01a1.993 1.993 0 00-.152-.756z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgOutgoing
